import { render, staticRenderFns } from "./AppointmentsFilter.vue?vue&type=template&id=ef294888&"
import script from "./AppointmentsFilter.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports